import { DatePipe } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FileUpload } from 'primeng/fileupload';
import { LocalStorage, MenuItemsAccess } from 'src/app/appCommon/Enums/enum';
import { StandardProcessService } from 'src/app/appServices/DefineService/standardProcess-service';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { ObservableService } from 'src/app/appServices/ObservableService/observable.service';
import { ToasterService } from 'src/app/appServices/ToasterService/toaster.service';
import { uploadTypeListPost, uploadTypeListPre } from 'src/app/appWeb/shared/shared';


@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {
  @ViewChild('fileUploader') fileUploader: any = ElementRef;
  uploadedFiles: any[] = [];
  uploadTypeListPre = uploadTypeListPre;
  uploadTypeListPost = uploadTypeListPost;
  @Input() selectedDropdownValue:any = '';
  @Input() selectedUploadDate:any = new Date();
  @Input() selectedFilesBase64Array:any = [];
  @Input() firstElement: any;
  @Input() type: any;
  uploadDisableBool:boolean = true;
  datePipe = new DatePipe('en-US');
  facilityKey: any;
  mbErrorbool: boolean = false;
  deleteFileBool: boolean = false;
  countTotalSize: number = 0;
  componentName:any = '';
  roleAccessResult: any;
  isAccessRead: boolean = false;
  constructor(public standardProcessService: StandardProcessService,private Observable: ObservableService,
    private helperService: HelperService, private router: Router,private toastService: ToasterService,) {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
     }

  ngOnInit(): void {
    this.standardProcessService._standerdProcessComponent.FileUploadComponent = this;
    this.componentName = localStorage.getItem("componentName");
    this.facilityKey = localStorage.getItem('facilityKey');

    this.roleAccessResult = JSON.parse(this.helperService.decryption(localStorage.getItem('roleAccessResult'))); 
    this.isAccessRead = this.roleAccessResult.some((x: any) => {
      return (
        (x.com_page_title === MenuItemsAccess.StandardProcessRead && x.cac_isAllowed) ||
        (x.com_page_title === MenuItemsAccess.StandardProcessReadWrite && !x.cac_isAllowed)
      );
    });
    
    if (this.isAccessRead && 
      this.roleAccessResult.some((x: any) =>
        x.com_page_title === MenuItemsAccess.StandardProcessRead && x.cac_isAllowed
      ) &&
      this.roleAccessResult.some((x: any) =>
        x.com_page_title === MenuItemsAccess.StandardProcessReadWrite && x.cac_isAllowed
      )
  ) {
    this.isAccessRead = false;
  }
  }
 
  ClearUploadedFileEvent(){
    this.fileUploader._files = [];
    this.selectedFilesBase64Array = [];
    this.countTotalSize = 0;
    this.onUpload(this.fileUploader,this.fileUploader,true);
  }
  
  onUpload(event: {files: any},fileUploader:any,value:any) {
    for(let file of event.files) {
        this.uploadedFiles.push(file);
    }
    if(value){
    fileUploader.clear();
    }
}
convertToBase64(event:any){
  this.countTotalSize = event.files.reduce((total: number, item: any) => total + item.size, 0);
  if(event.files.length > 1){
  this.checkTotalSize(this.countTotalSize);
  }
  if(this.countTotalSize < 5000000 && event.files.length == 1){
    if(this.componentName =='EMS'){
      this.standardProcessService._standerdProcessComponent.EMSComponent.CheckValueForUpload(false);
    }else if(this.componentName =='Inpatient'){
      this.standardProcessService._standerdProcessComponent.InpatientComponent.CheckValueForUpload(false);
    }else{
      this.standardProcessService._standerdProcessComponent.TriageWalkInComponent.CheckValueForUpload(false);
    }
  }
  if(this.selectedFilesBase64Array.length >0){
    event.files = this.getDifference(event.files,this.selectedFilesBase64Array);
  }
  var totalSize = 0;
  let bool:boolean = false;
  if(event.files.length == 1 && event.files[0].size > 5000000 && this.selectedFilesBase64Array.length == 0){
    this.ClearUploadedFileEvent();
    this.toastService.emptyField('Selected files more than 5mb. please select document size below 5mb.');
  }else{
  event.files.forEach((item:any,index:any)=>{
    var selectedFile: FileList = item;
    var name = item.name;
    event.files
    if (selectedFile) {
        var fileToLoad:any = selectedFile;
        var fileReader = new FileReader();
        this.selectedUploadDate = this.datePipe.transform(this.selectedUploadDate, 'MM/dd/yyyy');
        this.Observable.value$.next(true);
        var base64: any;
        fileReader.onload = () => {
            base64 = fileReader.result;

            const sizeInBytes = base64.length;
            totalSize += sizeInBytes;
             this.selectedFilesBase64Array.push({
               qfs_facilityId: this.facilityKey,
               qfs_workFlowType:this.firstElement,
                qfs_url: btoa(base64), 
                qfs_fileName: fileToLoad.name,
                qfs_uploadedDocument: this.selectedDropdownValue,
                qfs_FileUploadingDate: this.selectedUploadDate,
                qfs_CreatedBy: '',
                qfs_CreatedByName: '',
                qfs_CreatedByDate: this.standardProcessService.getTodayDate(),
                qfs_ModifiedBy: this.helperService.decryption(localStorage.getItem(LocalStorage.UId)),
               qfs_ModifiedByName: this.helperService.decryption(localStorage.getItem(LocalStorage.UName)),
               qfs_ModifiedByDate: null,
               qfs_ImplementaionType:this.type
             });
          };
       // Convert data to base64
       fileReader.readAsDataURL(fileToLoad);
   }
  })
}
}
checkTotalSize(total:any){
  if(total > 5000000){
    this.mbErrorbool = true;
    this.deleteFileBool = true;
    if(this.componentName =='EMS'){
      this.standardProcessService._standerdProcessComponent.EMSComponent.CheckValueForUpload(true);
    }else if(this.componentName =='Inpatient'){
      this.standardProcessService._standerdProcessComponent.InpatientComponent.CheckValueForUpload(true);
    }else{
      this.standardProcessService._standerdProcessComponent.TriageWalkInComponent.CheckValueForUpload(true);
    }
    this.toastService.emptyField(`Total size more than 5mb. Please delete one of following`);
  }else if(total > 0 && total <= 5000000){
    this.mbErrorbool = false;
    this.deleteFileBool = false;
    if(this.componentName =='EMS'){
      this.standardProcessService._standerdProcessComponent.EMSComponent.CheckValueForUpload(false);
    }else if(this.componentName =='Inpatient'){
      this.standardProcessService._standerdProcessComponent.InpatientComponent.CheckValueForUpload(false);
    }else{
      this.standardProcessService._standerdProcessComponent.TriageWalkInComponent.CheckValueForUpload(false);
    }
  }else{
  this.mbErrorbool = false;
  this.deleteFileBool = false;
  if(this.componentName =='EMS'){
    this.standardProcessService._standerdProcessComponent.EMSComponent.CheckValueForUpload(true);
  }else if(this.componentName =='Inpatient'){
    this.standardProcessService._standerdProcessComponent.InpatientComponent.CheckValueForUpload(true);
  }else{
    this.standardProcessService._standerdProcessComponent.TriageWalkInComponent.CheckValueForUpload(true);
  }
}

}
 getDifference(array1:any, array2:any) {
  return array1.filter((object1:any) => {
    return !array2.some((object2:any) => {
      return object1.name === object2.qfs_fileName;
    });
  });
}
  CheckDropDownAndDateSelected(){
    if(this.selectedDropdownValue && this.selectedUploadDate){
        this.uploadDisableBool = false;
        }else{
          this.uploadDisableBool = true;
        }
    }
    removeFile(file: any, uploader: FileUpload){ 
      const index = uploader.files.indexOf(file);
      uploader.remove(file, index);
      this.selectedFilesBase64Array.forEach((element: any, index: any) => {
        element.qfs_fileName == file.name  ? this.selectedFilesBase64Array.splice(index,1) : '';
       });
       
       this.countTotalSize = uploader.files.reduce((total: number, item: any) => total + item.size, 0);
       this.checkTotalSize(this.countTotalSize);
    }
}
